<template>
	<div>
		<template v-if="loading">
			<h4 class="text-center pt-5">
				Veuillez patienter... <br />
				Nous vérifions votre paiement avec la banque... <br />
				<CSpinner color="info" />
			</h4>
		</template>
		<template v-else>
			<!-- error -->
			<div v-if="this.errorMsg != null">
				<h4 class="text-center pt-5" v-html="errorMsg" />
			</div>

			<!-- payment ok -->
			<div v-if="this.errorMsg == null">Paiement validé, redirection en cours..</div>
		</template>
	</div>
</template>

<script>
	export default {
		name: 'cb-payment-verify',

		data() {
			return {
				loading: true,
				errorMsg: null,
			};
		},

		mounted() {
			this.$axios
				.get(`/api/orders/ipn/${this.$route.params.id}`, { params: this.$route.query })
				.then(() => {
					this.loading = false;
					this.$router.push(`/orders/${this.$route.params.id}/edit`);
				})
				.catch(res => {
					this.loading = false;
					this.errorMsg = res.response.data['hydra:description'];
				});
		},
	};
</script>
